import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { style: {"display":"block","margin-bottom":"8px"} }, "Bestand(en)", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { style: {"display":"block","margin-bottom":"8px"} }, "Opmerking(en)", -1)
const _hoisted_4 = ["innerHTML"]

import { computed, onMounted, ref } from 'vue'
import { surveyStore } from '@/stores/survey'
import TextEditor from '@/components/TextEditor.vue'
import Uploader from '@/components/Uploader.vue'
import SurveyAnswerIssues from '@/components/survey/SurveyAnswerIssues.vue'
import axios from 'axios'
import Filelist from '@/components/Filelist.vue'
import { notification } from 'ant-design-vue'
import { FileImageFilled, WarningFilled } from '@ant-design/icons-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurveyEvidenceCard',
  props: {
    question: null,
    questionIndex: null
  },
  setup(__props: any) {

const props = __props as { question:{ id:number, name:string, answer: { id:number, answer:string|null, note:string|null, media:{ id:number, url:string }[], issues:{ id:number, description:string, status:number }[] } }, questionIndex: number };



const screenWidth = computed(() => window.innerWidth)
const answer = ref<{ id?:number, answer:string|null, note:string|null, media:{ id:number, url:string }[], issues:{ id:number, description:string, status:number }[] }>({ answer: null, note: null, media: [], issues: [] })

onMounted(() => {
  answer.value.id = props.question.answer.id
  answer.value.answer = props.question.answer.answer
  answer.value.note = props.question.answer.note
  answer.value.media = props.question.answer.media
  answer.value.issues = props.question.answer.issues
})

function answerNoteChanged (val:string) : void {
  answer.value.note = val
  surveyStore().updateAnswer(props.question.answer.id, answer.value)
}

function addAnswerMedia (file:File) : void {
  const formData = new FormData()
  formData.append('files', file)

  axios.post(process.env.VUE_APP_API_URL + '/surveys/answers/' + props.question.answer.id + '/media/add', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => {
    answer.value.media.push(r.data.data)
  })
}

function updateAnswerMedia (data:{ file:File, mediaId:number }) : void {
  const formData = new FormData()
  formData.append('files', data.file)
  formData.append('mediaId', data.mediaId.toString())

  axios.post(process.env.VUE_APP_API_URL + '/surveys/answers/' + props.question.answer.id + '/media/update', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => {
    answer.value.media.forEach((m:{ id:number }, index) => {
      if (m.id === data.mediaId) {
        answer.value.media[index] = r.data.data
        notification.success({
          message: 'Afbeelding bijgewerkt.',
          description: 'De afbeelding is succesvol bijgewerkt.',
          duration: 5
        })
      }
    })
  })
}

function deleteFile (file:{ id:number }) : void {
  axios.post(process.env.VUE_APP_API_URL + '/surveys/answers/' + props.question.answer.id + '/media/delete', { mediaId: file.id }).then(() => {
    answer.value.media.forEach((m:{ id:number }, index) => {
      if (m.id === file.id) {
        answer.value.media.splice(index, 1)
        notification.success({
          message: 'Bestand verwijderd.',
          description: 'Het bestand is succesvol verwijderd.',
          duration: 5
        })
      }
    })
  })
}

function issueAdded (issue:{ id:number, description:string, status:number }) : void {
  answer.value.issues.push(issue)
}

function issueUpdated (issue:{ id:number, description:string, status:number }) : void {
  answer.value.issues.forEach((i:{ id:number, description:string, status:number }, index) => {
    if (i.id === issue.id) {
      answer.value.issues[index] = issue
    }
  })
}

function issueDeleted (id:number) : void {
  answer.value.issues.forEach((i:{ id:number, description:string, status:number }, index) => {
    if (i.id === id) {
      answer.value.issues.splice(index, 1)
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_collapse, { bordered: false }, {
    default: _withCtx(() => [
      _createVNode(_component_a_collapse_panel, { style: {"background":"white","border-bottom":"1px solid #e8e8e8"} }, _createSlots({
        header: _withCtx(() => [
          _createElementVNode("b", null, _toDisplayString(__props.question.number) + ". " + _toDisplayString(__props.question.name), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_collapse, { bordered: false }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_collapse_panel, {
                        header: "Controlepunten",
                        style: {"border-bottom":"5px solid white"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            innerHTML: __props.question.description
                          }, null, 8, _hoisted_1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  (!_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner)
                    ? (_openBlock(), _createBlock(Uploader, {
                        key: 0,
                        "current-count": answer.value.media.length,
                        allowedMimeTypes: ['image/jpeg', 'image/png', 'application/pdf'],
                        "upload-button": "",
                        onNewFileUploaded: addAnswerMedia
                      }, null, 8, ["current-count"]))
                    : _createCommentVNode("", true),
                  (answer.value.media.length)
                    ? (_openBlock(), _createBlock(Filelist, {
                        key: 1,
                        media: answer.value.media,
                        "can-tag": "",
                        "tagging-disabled": _unref(surveyStore)().surveyClosed,
                        block: _unref(surveyStore)().survey.building_block,
                        building: _unref(surveyStore)().survey.building,
                        "answer-id": __props.question.answer.id,
                        onImageEdited: _cache[0] || (_cache[0] = ($event: any) => (updateAnswerMedia($event))),
                        onDeleteFile: deleteFile,
                        "can-edit": !_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner,
                        "can-comment": !_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner,
                        "can-delete": !_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner
                      }, null, 8, ["media", "tagging-disabled", "block", "building", "answer-id", "can-edit", "can-comment", "can-delete"]))
                    : (!_unref(surveyStore)().isSurveyOwner)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode("-")
                        ], 64))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  (!_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner)
                    ? (_openBlock(), _createBlock(TextEditor, {
                        key: 0,
                        content: answer.value.note,
                        returnOn: "blur",
                        onContentChange: _cache[1] || (_cache[1] = ($event: any) => (answerNoteChanged($event)))
                      }, null, 8, ["content"]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        innerHTML: answer.value.note || '-'
                      }, null, 8, _hoisted_4))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 2
      }, [
        (__props.question.required)
          ? {
              name: "extra",
              fn: _withCtx(() => [
                _createVNode(_component_a_tag, {
                  color: "#f38929",
                  style: _normalizeStyle({ float: _unref(screenWidth) < 768 ? 'right' : 'left', marginBottom: _unref(screenWidth) < 768 ? '4px' : '' })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Verplicht")
                  ]),
                  _: 1
                }, 8, ["style"]),
                _createVNode(_component_a_tag, {
                  color: "#666",
                  style: _normalizeStyle({ float: _unref(screenWidth) < 768 ? 'right' : 'left' })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FileImageFilled)),
                    _createTextVNode(" " + _toDisplayString(answer.value.media.length), 1)
                  ]),
                  _: 1
                }, 8, ["style"])
              ]),
              key: "0"
            }
          : undefined
      ]), 1024)
    ]),
    _: 1
  }))
}
}

})